module.exports = __webpack_public_path__ + "static/media/work5.98a1de83.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work5.png
// module id = 86
// module chunks = 0